import React, {useState} from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Input from '../../../components/Input'
import SubmittableForm, {useFormValuesStorage} from '../../../components/FormSubmission'

const phoneBreakpoint = '@media only screen and (max-width: 500px)'

const Form = styled(SubmittableForm)`
	width: 100%;
`

const InputStyled = styled(Input)`
	margin: 0.6rem 0;
`
InputStyled.defaultProps = {
	inputStyle: 'cornered',
	noBorder: true,
}

const TextareaStyled = styled(Input)`
`
TextareaStyled.defaultProps = {
	textarea: true,
	inputStyle: 'cornered',
	noBorder: true,
}

const Title = styled.h2`
	font-size: ${props => props.theme.fontSizes.big20};
	margin-bottom: 2.25rem;
`

const InputContainer = styled.div`
	margin-right: 4rem;
	
	${phoneBreakpoint} {
		margin-right: 0;
	}
`


function ContactForm({className, data}) {
	const {setValue, clearValues, values, errors, isInvalid} = useFormValuesStorage({fields: data.fields})
	const [showErrors, setShowErrors] = useState(false)

	const shouldPreventSubmit = () => {
		if (isInvalid) {
			setShowErrors(true)
			return true
		}
	}

	return <Form
		values={values}
		shouldPreventSubmit={shouldPreventSubmit}
		formName='Contact form'
		submitLabel={data.submitLabel}
		className={className}
		clearValues={() => {
			setShowErrors(false)
			clearValues()
		}}>

		<Title>{data.title}</Title>
		{data.fields.map((one) => {
			const value = values[one.placeholder]
			const fieldErrors = errors[one.placeholder]

			const onChange = e => {
				setValue({fieldName: one.placeholder, value: e.target.value})
			}

			return <>
				{one.type === 'textarea' ?
					<TextareaStyled
						errors={showErrors ? fieldErrors : []}
						key={one.placeholder}
						inputProps={{required: true, placeholder: one.placeholder, type: one.type, value, onChange}}/> :
					<InputContainer
						key={one.placeholder}>
						<InputStyled
							errors={showErrors ? fieldErrors : []}
							inputProps={{
								required: true,
								placeholder: one.placeholder,
								type: one.type,
								value,
								onChange,
							}}/>
					</InputContainer>}
			</>
		})}
	</Form>
}

ContactForm.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		fields: PropTypes.arrayOf(PropTypes.shape({
			type: PropTypes.oneOf(['email', 'text', 'textarea']),
			placeholder: PropTypes.string.isRequired,
			required: PropTypes.bool.isRequired,
		}).isRequired).isRequired,
		submitLabel: PropTypes.string.isRequired,
	}).isRequired,
}

ContactForm.defaultProps = {
	className: '',
}

export default ContactForm
